import Box from "ds/components/Box";
import ListEntitiesItemDescriptionMultipleLines from "components/ListEntitiesItem/Description/MultipleLines";

import { CellComponentProps } from "../types";
import useIdpGroupRolesListAnalytics from "../useIdpGroupRolesListAnalytics";

type IdpGroupRolesListItemDescriptionCellProps = CellComponentProps;

const IdpGroupRolesListItemDescriptionCell = ({
  roleBinding,
}: IdpGroupRolesListItemDescriptionCellProps) => {
  const trackAnalytics = useIdpGroupRolesListAnalytics();

  const handleShowFullDescription = () => {
    trackAnalytics("Show full description clicked");
  };

  if (!roleBinding.role.description) {
    return null;
  }

  return (
    <Box direction="row" align="start">
      <ListEntitiesItemDescriptionMultipleLines
        lines={1}
        hasChevronLink
        description={roleBinding.role.description}
        onShowFullDescription={handleShowFullDescription}
      />
    </Box>
  );
};

export default IdpGroupRolesListItemDescriptionCell;
